import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=1d5613b2&"
import script from "./ValidateEmail.vue?vue&type=script&lang=ts&"
export * from "./ValidateEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports